import React from 'react'
import PropTypes from 'prop-types'
import { ButtonTabs, SquareButton } from 'ui/buttons'
import { useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import moment from 'moment'

function SpecialDaysDayFilter (props) {
  const initialDate = moment(props.date)

  const [value, setValue] = useFilterValue('date', initialDate.format('YYYY-MM-DD'))

  useWillConstrain('date', value)

  const days = [
    0, 1, 2, 3, 4, 5, 6
  ]

  const options = days.map((day) => {
    return moment(props.date).startOf('isoWeek').add(day, 'days')
  })

  return (
    <div className='flex group space-x-1'>
      {options.map(day => (
        <SquareButton key={day} onClick={() => setValue(day.format('YYYY-MM-DD'))} color='btn-lightgray' inactive={day.format('YYYY-MM-DD') !== value}>
          {day.format('dd')}
        </SquareButton>
      ))}
    </div>
  )
}

SpecialDaysDayFilter.defaultProps = {}

SpecialDaysDayFilter.propTypes = {
  date: PropTypes.string.isRequired
}

export default SpecialDaysDayFilter
